import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification, showSuccessNotification } from 'store/shared/actions';
import { TOKEN, REFRESH_TOKEN } from 'library/constants/auth';
import * as constants from './constants';
import * as actions from './actions';

function* getUser() {
  try {
    const { data } = yield call(request, API.USERS);

    yield put(actions.getUserSuccess(data));
  } catch (e) {
    yield put(actions.getUserError(e));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getUserWatcher() {
  yield takeEvery(constants.GET_USER, getUser);
}

function* updateUser(action) {
  try {
    yield call(request, `${API.USERS}/1`, 'PATCH', { data: action.payload, query: { _delay: 500 } });

    yield put(actions.updateUserSuccess());
    yield put(showSuccessNotification({ message: 'User settings successfully updated.' }));
  } catch (e) {
    yield put(showErrorNotification({ message: 'User settings update failed.' }));
    yield put(actions.updateUserError(e));
  } finally {
    yield put(actions.getUser());
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* updateUserWatcher() {
  yield takeEvery(constants.UPDATE_USER, updateUser);
}

function* login(action) {
  const { data, onSuccess } = action.payload;

  try {
    const { token, refreshToken } = yield call(request, API.LOGIN, 'POST', { data, skipRetry: true });

    if(token && refreshToken) {
      localStorage.setItem(TOKEN, token);

      localStorage.setItem(REFRESH_TOKEN, refreshToken);
      yield put(actions.loginSuccess());
      onSuccess();
    }
  } catch (e) {
    yield put(actions.loginError(e.message));

    yield put(showErrorNotification({ message: e.message }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* loginWatcher() {
  yield takeEvery(constants.LOGIN, login);
}
